import React, { useState, useContext, useRef, useMemo, useCallback, useEffect } from "react";
import './../assets/css/resizablediv.css'
import DockLayout from 'rc-dock'
import "rc-dock/dist/rc-dock.css";
import './../assets/css/dockpanel.css';
import { DatabaseContext } from "../redux/DatabaseStore";
import { ContextMenu } from 'primereact/contextmenu';
import FavoriteMenu from "./recursive_menu/FavoriteMenu";
import { Dialog } from 'primereact/dialog';
import { deleteRequest, getRequest, postRequest } from "../api/ApiController";
import { InfinitySpin } from  'react-loader-spinner';
import LastUsedMenu from "./recursive_menu/LastUsedMenu";
import { components } from "../components/TabPanelList";
import UtilContext from "../components/UtilContext";
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, LoadPrioIcon} from "./svg/svgIcons";
import { LocaleContext } from "../components/LocaleContext";


const FavoriteContext = React.createContext();
const LastUsedContext = React.createContext();
const FastViewContext = React.createContext();

/** Stĺpce/atribúty z fast_views – Laravel môže poslať už ako objekt (JSON cast), nie string. */
function parseStoredJsonField(raw, fallback = null) {
  if (raw == null || raw === "") return fallback;
  if (typeof raw === "object") return raw;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return fallback;
    }
  }
  return fallback;
}

function HomePage() {

  const [state,dispatch] = useContext(DatabaseContext);
  const {openFavoriteDialog,setFastView} = useContext(UtilContext);
  const { t, locale } = useContext(LocaleContext);

  const [favorite,setFavorite] = useState(null);
  const [visibleSearch,setVisibleSearch] = useState(false);
  const [visibleLoading,setVisibleLoading] = useState(false);
  const [newValue,setNewValue] = useState('');
  const [dialogHeader,setDialogHeader] = useState('');
  const [operation,setOperation] = useState('');
  

  const divFav = useRef(null);
  const groupFav = useRef(null);
  const fav = useRef(null);
  const lastUsedFav = useRef(null);
  const dockRef = useRef(null);

  const hideAll = useCallback(() => {
    divFav.current?.hide?.();
    fav.current?.hide?.();
    groupFav.current?.hide?.();
    lastUsedFav.current?.hide?.();
  }, []);

  const props = useMemo(
    () => ({ divFav, groupFav, fav, lastUsedFav, hideAll, setFavorite }),
    [hideAll]
  );

  const divItems = useMemo(
    () => [
      {
        label: t('Home.Favorites.Context.AddGroup'),
        icon: 'pi pi-fw pi-clone',
        command: () => {
          setNewValue('');
          setDialogHeader(t('Home.Favorites.Dialog.CreateGroup'));
          setOperation('create_group');
          setVisibleSearch(true);
        },
      },
    ],
    [t],
  );

  const lastUsedItems = useMemo(
    () => [
      {
        label: t('Home.LastUsed.Context.AddToFavorites'),
        icon: <FavoriteIcon />,
        command: () => {
          openFavoriteDialog(favorite?.name, favorite?.page);
        },
      },
      {
        label: t('Home.LastUsed.Context.AddToFastView'),
        icon: <PriceIcon />,
        command: () => {
          setFastView(favorite?.page, null, null);
        },
      },
    ],
    [t, favorite, openFavoriteDialog, setFastView],
  );

  const groupItems = useMemo(
    () => [
      {
        label: t('Home.Favorites.Group.Context.Rename'),
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          setNewValue(favorite?.name ?? '');
          setDialogHeader(t('Home.Favorites.Group.Dialog.RenameTitle'));
          setOperation('rename_group');
          setVisibleSearch(true);
        },
      },
      {
        label: t('Home.Favorites.Group.Context.Delete'),
        icon: 'pi pi-fw pi-trash',
        command: () => {
          setNewValue('');
          setDialogHeader(t('Home.Favorites.Group.Dialog.DeleteConfirm'));
          setOperation('delete_group');
          setVisibleSearch(true);
        },
      },
    ],
    [t, favorite],
  );

  const favItems = useMemo(
    () => [
      {
        label: t('Home.Favorites.Context.Rename'),
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          setNewValue(favorite?.name ?? '');
          setDialogHeader(t('Home.Favorites.Dialog.RenameFavoriteTitle'));
          setOperation('rename_favorite');
          setVisibleSearch(true);
        },
      },
      {
        label: t('Home.Favorites.Context.Delete'),
        icon: 'pi pi-fw pi-trash',
        command: () => {
          setNewValue(null);
          setDialogHeader(t('Home.Favorites.Dialog.DeleteFavoriteConfirm'));
          setOperation('delete_favorite');
          setVisibleSearch(true);
        },
      },
      {
        label: t('Home.Favorites.Context.ChangeGroup'),
        icon: 'pi pi-fw pi-sort',
        command: () => {
          setNewValue(favorite?.favorite_group_id ?? '');
          setDialogHeader(t('Home.Favorites.Dialog.ChangeGroupTitle'));
          setOperation('change_group');
          setVisibleSearch(true);
        },
      },
      {
        label: t('Home.Favorites.Context.AddToFastViewQuick'),
        icon: 'pi pi-fw pi-star',
        command: () => {
          setFastView(favorite?.page, null, null);
        },
      },
    ],
    [t, favorite, setFastView],
  );

  const favorites = useMemo(
    () => ({
      content: (
        <div
          className="h-full"
          onContextMenu={(e) => {
            hideAll();
            divFav.current?.show(e);
          }}
        >
          <ul className="space-y-1 text-sm" style={{ backgroundColor: "#333" }}>
            <FavoriteContext.Consumer>
              {(value) => {
                if (value != null) {
                  return <FavoriteMenu items={value} depth={1} props={props} />;
                }
                return null;
              }}
            </FavoriteContext.Consumer>
          </ul>
        </div>
      ),
      closable: false,
    }),
    [hideAll, props, t]
  );

  const last_used = useMemo(
    () => ({
      content: (
        <div className="h-full">
          <ul className="space-y-1 text-sm" style={{ backgroundColor: "#333" }}>
            <LastUsedContext.Consumer>
              {(value) => <LastUsedMenu items={value} props={props} />}
            </LastUsedContext.Consumer>
          </ul>
        </div>
      ),
      closable: false,
    }),
    [props]
  );

  const fast_view = useMemo(
    () => ({
      content: (
        <div className="h-full">
          <ul className="space-y-1 text-sm" style={{ backgroundColor: "#333" }}>
            <FastViewContext.Consumer>
              {(value) => {
                const list = Array.isArray(value) ? value : [];
                if (!list.length) return null;
                const row = list[0];
                const Page = row?.page != null ? components[row.page] : null;
                if (!Page) {
                  return (
                    <li className="p-2 text-amber-200 text-xs list-none">
                      {t('Home.FastView.UnknownPage').replace(/\{\{page\}\}/g, String(row?.page ?? ''))}
                    </li>
                  );
                }
                const columnsVisible = parseStoredJsonField(row.columns, {});
                const extra = parseStoredJsonField(row.attributes, {}) || {};
                return <Page key={row.id ?? row.page} {...extra} columns_visible={columnsVisible} />;
              }}
            </FastViewContext.Consumer>
          </ul>
        </div>
      ),
      closable: false,
    }),
    [t]
  );

  const box = useMemo(
    () => ({
      dockbox: {
        mode: "vertical",
        children: [
          {
            mode: "horizontal",
            children: [
              {
                size: 100,
                tabs: [{ ...favorites, id: "t1", title: t("Favoriti") }],
              },
              {
                size: 100,
                tabs: [{ ...last_used, id: "t2", title: t("Posledne pouzite") }],
              },
              {
                size: 300,
                tabs: [{ ...fast_view, id: "t3", title: t("Rychly nahlad") }],
              },
            ],
          },
        ],
      },
    }),
    [locale, t, favorites, last_used, fast_view]
  );

  // Display-only locale update for dock tab titles — avoid remounting the shell on locale change.
  useEffect(() => {
    if (dockRef.current && typeof dockRef.current.loadLayout === 'function') {
      dockRef.current.loadLayout(box);
    }
  }, [box]);

  function confirmMyDialog(){
    setVisibleSearch(false);
    setVisibleLoading(true);
    if(operation=="rename_favorite" || operation=="rename_group"){
      console.log("Favorite",favorite);
      let db_favorite = {...favorite};
      db_favorite.name = newValue;
      let formData = new FormData();
      for (let value in db_favorite) {
          formData.append(value, db_favorite[value]);
      }
      let url = operation=="rename_favorite" ? `/api/favorites/update/${db_favorite.id}`: `/api/favorite_groups/update/${db_favorite.id}`;
      postRequest(url, formData,true)
      .then((response) => {
          getRequest("/api/my_favorite_groups").then((response) => {
            dispatch({type:'load_favorites',newFavorites:response.data});
            setVisibleLoading(false);
        });
      }).catch((reason) => {
          setVisibleLoading(false);
          if(!navigator.online){
              alert(t("ServiceTask.OfflineQueuedAlert"));
          }
          else{
              alert(t("ServiceTask.ActionFailed"));
          }
      })
    }
    if(operation=="delete_favorite" || operation=="delete_group"){
      console.log("Favorite",favorite);
      
      let db_favorite = {...favorite};

      let url = operation=="delete_favorite" ? `/api/favorites/${db_favorite.id}`: `/api/favorite_groups/${db_favorite.id}`;
      deleteRequest(url)
      .then((response) => {
          getRequest("/api/my_favorite_groups").then((response) => {
            dispatch({type:'load_favorites',newFavorites:response.data});
            setVisibleLoading(false);
        });
      }).catch((reason) => {
          setVisibleLoading(false);
          if(!navigator.online){
              alert(t("ServiceTask.OfflineQueuedAlert"));
          }
          else{
              alert(t("ServiceTask.ActionFailed"));
          }
      })
    }
    else if(operation=="change_group"){
      console.log("Favorite",favorite);
      let db_favorite = {...favorite};
      db_favorite.favorite_group_id = newValue;
      let formData = new FormData();
      for (let value in db_favorite) {
          formData.append(value, db_favorite[value]);
      }
      postRequest(`/api/favorites/update/${db_favorite.id}`, formData,true)
      .then((response) => {
          getRequest("/api/my_favorite_groups").then((response) => {
            dispatch({type:'load_favorites',newFavorites:response.data});
            setVisibleLoading(false);
        });
      }).catch((reason) => {
          setVisibleLoading(false);
          if(!navigator.online){
              alert(t("ServiceTask.OfflineQueuedAlert"));
          }
          else{
              alert(t("ServiceTask.ActionFailed"));
          }
      })
    }
    else if(operation=="create_group"){
      let formData = new FormData();
      formData.append("name", newValue);
      postRequest(`/api/favorite_groups`, formData,true)
      .then((response) => {
          getRequest("/api/my_favorite_groups").then((response) => {
            dispatch({type:'load_favorites',newFavorites:response.data});
            setVisibleLoading(false);
        });
      }).catch((reason) => {
          setVisibleLoading(false);
          if(!navigator.online){
              alert(t("ServiceTask.OfflineQueuedAlert"));
          }
          else{
              alert(t("ServiceTask.ActionFailed"));
          }
      })
    }
  }


return (
  <div className="h-[calc(100vh_-_137px)] relative">
    <FavoriteContext.Provider value={state.favorites}>
    <LastUsedContext.Provider value={state.last_used}>
    <FastViewContext.Provider value={state.fast_view}>
    <ContextMenu model={divItems} ref={divFav} breakpoint="767px" className="bg-[#333]"/>
    <ContextMenu model={groupItems} ref={groupFav} breakpoint="767px" className="bg-[#333]"/>
    <ContextMenu model={favItems} ref={fav} breakpoint="767px" className="bg-[#333]" />
    <ContextMenu model={lastUsedItems} ref={lastUsedFav} breakpoint="767px" className="bg-[#333]" />
      <Dialog header={dialogHeader} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
        <div className="flex flex-columns">
          
          {(operation=="rename_group" || operation=="rename_favorite" || operation=="create_group") && <input
              value={newValue} onChange={e => setNewValue(e.target.value)}
              type="text"
              className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
          />}
          {operation=="change_group" && 
          <select 
          value={newValue} onChange={e => setNewValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            {state.favorites.map((favorite_group) => (
              <option key={favorite_group.id} value={favorite_group.id}>{favorite_group.name}</option>
            ))}                          
          </select>
          }
          <button onClick={() => confirmMyDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{(operation=="delete_group" || operation=="delete_favorite") ? t("Home.Dialog.Button.Yes") : t("Home.Dialog.Button.Apply")}</button>
        </div>
      </Dialog>
      <Dialog visible={visibleLoading} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
            <InfinitySpin 
            width='208'
            color="#000"
            />
            <p className='text-2xl font-bold text-center w-52 text-black'>{t("Home.Loading")}</p>
            </Dialog>
      <DockLayout
      ref={dockRef}
      defaultLayout={box}
      style={{ position: "absolute",top:10,left:10,bottom:10,right:10
      }}
    />
    </FastViewContext.Provider>
    </LastUsedContext.Provider>
    </FavoriteContext.Provider>
            {/*<div className="w-auto h-screen m-4 bg-white border-black border-2 rounded-md shadow-md resize">
                <h1 className="bg-zinc-900 p-2 text-xl font-semibold text-left text-white" >
                   Favoriti
                </h1>
            </div> 
            <div className="w-auto h-screen m-4 bg-white border-black border-2 rounded-md shadow-md resize">
                <h1 className="bg-zinc-900 p-2 text-xl font-semibold text-left text-white">{t('Ui.R67.Posledne_pouzite')}</h1>
            </div>
                          
            
            <div className="w-auto h-screen m-4 bg-white border-black border-2 rounded-md shadow-md resize">
                <h1 className="bg-zinc-900 p-2 text-xl font-semibold text-left text-white">{t('Ui.R67.Rychly_pristup')}</h1>
</div>*/}    
</div>
/*<ResizableDiv>
        <div className='bg-zinc-900'>
          <h3 className='bg-zinc-800 text-gray-100 text-center font-bold text-xl py-3'>Favoriti</h3>
          <Menu items={menuItems} depth={1}/>
        </div>
      </ResizableDiv>
      <ResizableDiv>
        <div>
          <h3 className='bg-zinc-800 text-gray-100 text-center font-bold text-xl py-3'>{t('Ui.R67.RecentlyUsed')}</h3>
        </div>
      </ResizableDiv>
      <ResizableDiv>
        <div>
          <h3 className='bg-zinc-800 text-gray-100 text-center font-bold text-xl py-3'>{t('Ui.R67.Rychly_pristup')}</h3>
        </div>
</ResizableDiv>*/
    )
}

export default HomePage;